export default __webpack_public_path__ + "static/media/left.69c82915.png";